import i18n from 'I18n';
import { memo } from 'react';
import styled from 'foundations-theming/utils';
import { NOTIFICATION_CLOSE_BUTTON_OFFSET } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
const Clickable = styled.button.withConfig({
  displayName: "CloseButton__Clickable",
  componentId: "sc-1vd8d7j-0"
})(({
  theme,
  smallerClickArea
}) => {
  return {
    color: theme.color['icon-core-subtle'],
    position: 'absolute',
    right: NOTIFICATION_CLOSE_BUTTON_OFFSET,
    top: NOTIFICATION_CLOSE_BUTTON_OFFSET,
    width: theme.space['300'],
    height: theme.space['300'],
    border: 'none',
    background: 'none',
    padding: 0,
    margin: 0,
    '&::after': {
      content: ' ',
      borderRadius: '50%',
      left: '50%',
      padding: smallerClickArea ? theme.space['250'] : theme.space['500'],
      position: 'absolute',
      top: '50%',
      transform: 'translate(-50%, -50%)'
    },
    '&:hover': {
      cursor: 'pointer',
      color: theme.color['icon-core-default']
    }
  };
});
const CloseIcon = styled.svg.withConfig({
  displayName: "CloseButton__CloseIcon",
  componentId: "sc-1vd8d7j-1"
})(["color:inherit;display:block;flex-grow:1;&::after{padding:16px;}"]);
const CloseIconInner = styled.path.withConfig({
  displayName: "CloseButton__CloseIconInner",
  componentId: "sc-1vd8d7j-2"
})(["fill:currentColor;stroke:currentColor;stroke-width:2;"]);
/**
 * Small cross button for use within notifications
 */
const CloseButton = ({
  onClick,
  smallerClickArea
}) => {
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(Clickable, {
      onClick: onClick,
      "data-test-id": "notification-close-button",
      "aria-label": i18n.text('realTime.closeNotificationIcon'),
      smallerClickArea: smallerClickArea,
      children: /*#__PURE__*/_jsx(CloseIcon, {
        viewBox: "0 0 14 14",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/_jsx(CloseIconInner, {
          d: "M14.5,1.5l-13,13m0-13,13,13",
          transform: "translate(-1 -1)"
        })
      })
    })
  );
};
export default /*#__PURE__*/memo(CloseButton);